import { Content, LoaderWrapper } from '@anm/components/buttons/ButtonLoader';
import { flexRow, media, truncate } from '@anm/styles/helpers';
import styled from 'styled-components';

import { Label } from '../../../StreamModalWrapper';

export const InstructionRow = styled(Label)`
  ${flexRow};

  div {
    margin-right: 10px;
  }
`;

const mobileButtons = media.phone`
  button {
    padding: 0;
  }
`;

export const ButtonsContainer = styled.div`
  ${flexRow};
  margin-top: 24px;
  column-gap: 10px;
  justify-content: space-between;

  ${Content} {
    opacity: 1;
  }

  ${LoaderWrapper} {
    left: 13%;
  }

  button {
    flex: 1;
    padding: 0 30px;
    position: relative;
  }

  ${mobileButtons}
`;

export const PreviewRow = styled.div`
  ${flexRow};
  min-height: 80px;
  margin-bottom: 20px;
`;

export const Hint = styled.p`
  display: flex;
  font-size: 14px;
  margin-left: 16px;
  line-height: 18px;
  align-items: center;
`;

export const InfoWrapper = styled.div`
  margin-bottom: 30px;
  h3,
  span {
    ${truncate('100%')}
  }
`;
